import Noticias from "../views/Noticias/Noticias";
import MainPublicaciones from "../views/Publicaciones/MainPublicaciones";
import AdmisionAdmin from "../views/AdmisionAdmin/AdmisionAdmin";
import Reinscripciones from "../views/Administracion/Reinscripciones";
import MainEstadoDeCuenta from "../views/Administracion/MainEstadoDeCuenta";
import AdminSolicitudes from "../views/Administracion/AdminSolicitudes";
import ControlDeIngresos from "../views/Administracion/ControlDeIngresos";
import Cobranzas from "../views/Administracion/Cobranzas";

import MainRegistrosAdmin from "../views/Registros/MainRegistrosAdmin";
import OpcionesAdmin from "../views/Opciones/OpcionesAdmin";
import BienestarMain from "../views/Bienestar/BienestarMain";
import MainEnvios from "../views/Envios/MainEnvios";

const Administrativo = [
    {
      path: "/noticias",
      name: "Noticias",
      icon: "pe-7s-news-paper",
      component: Noticias,
      color:"#424242"
    },
    {
      path: "/publicaciones",
      name: "Publicaciones",
      icon: "pe-7s-check",
      component: MainPublicaciones,
      color:"#424242"
    },
    {
      path: "/registros_admin",
      name: "Registros",
      icon: "pe-7s-plus",
      component: MainRegistrosAdmin,
      color:"#424242"
    },
    {
      path: "/admision_admin",
      name: "Admisiones",
      icon: "pe-7s-note2",
      component: AdmisionAdmin,
      color:"#424242"
    },
    {
      path: "/reincripciones",
      name: "Reinscripciones",
      icon: "pe-7s-copy-file",
      component: Reinscripciones,
      color:"#424242"
    },
    {
      path: "/estados_de_cuenta",
      name: "Estados de Cuenta",
      icon: "pe-7s-credit",
      component: MainEstadoDeCuenta,
      color:"#424242"
    },
    {
      path: "/admin_solicitudes",
      name: "Solicitudes",
      icon: "pe-7s-note",
      component: AdminSolicitudes,
      color:"#424242"
    },
    {
      path: "/ingresos",
      name: "Ingresos",
      icon: "pe-7s-piggy",
      component: ControlDeIngresos,
      color:"#424242"
    },
    {
      path: "/cobranzas",
      name: "Cobranzas",
      icon: "pe-7s-cash",
      component: Cobranzas,
      color:"#424242"
    },
    {
      path: "/preferencias_admin",
      name: "Opciones",
      icon: "pe-7s-tools",
      component: OpcionesAdmin,
      color:"#424242"
    },
    {
      path: "/bienestar_estudiantil",
      name: "Bienestar Est.",
      icon: "pe-7s-coffee",
      component: BienestarMain,
      color:"#424242"
    },
    {
      path: "/notificaciones",
      name: "Notificaciones",
      icon: "pe-7s-mail",
      component: MainEnvios,
      color:"#424242"
    },
    {
      path: "/Home",
      name: "Inicio",
      icon: "pe-7s-home",
      component: Noticias,
      color:"#424242"
    }
];

export default Administrativo;


// WEBPACK FOOTER //
// ./src/routes/Administrativo.jsx